export default __webpack_public_path__ + "static/media/mac.1fe59de3.svg";